export const DEFAULT_PHOTO_CREDITS = 2;

const PHOTO_QUALITY_SURCHARGE = {
  '1.5K': 0,
  '2K': 1,
};

export const VIDEO_CREDITS = {
  LQ: 25,
  MQ: 54,
  Q_480P: 25,
  Q_720P: 54,
};

export function getPhotoCreditCost(baseCredits, quality = '1.5K') {
  const parsedBase = Number(baseCredits);
  const base = Number.isFinite(parsedBase) && parsedBase >= DEFAULT_PHOTO_CREDITS
    ? parsedBase
    : DEFAULT_PHOTO_CREDITS;
  return base + (PHOTO_QUALITY_SURCHARGE[quality] ?? 0);
}

export function getVideoCreditCost(quality) {
  return VIDEO_CREDITS[quality] ?? VIDEO_CREDITS.LQ;
}
